const MIN_COMPLETION_TIME_MS = 3000;
const DUPLICATE_WINDOW_MS = 5 * 60 * 1000;
const PENDING_STORAGE_KEY = 'harbinger-contact-pending';
const LAST_SUBMISSION_STORAGE_KEY = 'harbinger-contact-last-submission';

function readSessionValue(key) {
  try {
    return window.sessionStorage.getItem(key);
  } catch (error) {
    return null;
  }
}

function writeSessionValue(key, value) {
  try {
    window.sessionStorage.setItem(key, value);
  } catch (error) {
    // Storage can be unavailable in privacy modes. The form should still work.
  }
}

function removeSessionValue(key) {
  try {
    window.sessionStorage.removeItem(key);
  } catch (error) {
    // Storage can be unavailable in privacy modes. The form should still work.
  }
}

function hashString(value) {
  let hash = 2166136261;

  for (let index = 0; index < value.length; index += 1) {
    hash ^= value.charCodeAt(index);
    hash = Math.imul(hash, 16777619);
  }

  return (hash >>> 0).toString(16);
}

function submissionFingerprint(form) {
  const contactFields = Array.from(new FormData(form).entries())
    .filter(([name]) => name.startsWith('contact[') && name !== 'contact[Website]')
    .map(([name, value]) => `${name}:${String(value).trim().toLowerCase()}`)
    .sort();

  return hashString(contactFields.join('|'));
}

function showMessage(messageElement, message) {
  if (!messageElement) return;

  messageElement.textContent = message;
  messageElement.hidden = false;
}

function hideMessage(messageElement) {
  if (!messageElement) return;

  messageElement.hidden = true;
  messageElement.textContent = '';
}

function recordSuccessfulSubmission(messageElement) {
  if (messageElement?.dataset.contactPosted !== 'true') return;

  const pendingFingerprint = readSessionValue(PENDING_STORAGE_KEY);
  if (!pendingFingerprint) return;

  writeSessionValue(LAST_SUBMISSION_STORAGE_KEY, JSON.stringify({
    fingerprint: pendingFingerprint,
    submittedAt: Date.now()
  }));
  removeSessionValue(PENDING_STORAGE_KEY);
}

function wasRecentlySubmitted(fingerprint) {
  const storedSubmission = readSessionValue(LAST_SUBMISSION_STORAGE_KEY);
  if (!storedSubmission) return false;

  try {
    const submission = JSON.parse(storedSubmission);
    return submission.fingerprint === fingerprint
      && Date.now() - submission.submittedAt < DUPLICATE_WINDOW_MS;
  } catch (error) {
    removeSessionValue(LAST_SUBMISSION_STORAGE_KEY);
    return false;
  }
}

function protectContactForm(honeypot) {
  const form = honeypot.closest('form');
  if (!form || form.dataset.spamProtectionInitialized === 'true') return;

  form.dataset.spamProtectionInitialized = 'true';
  const loadedAt = Date.now();
  const messageElement = form.querySelector('[data-contact-form-message]');

  recordSuccessfulSubmission(messageElement);

  form.addEventListener('input', () => hideMessage(messageElement));
  form.addEventListener('submit', (event) => {
    if (honeypot.value.trim() !== '') {
      event.preventDefault();
      form.reset();
      showMessage(messageElement, "Thanks for contacting us. We'll get back to you as soon as possible.");
      return;
    }

    if (Date.now() - loadedAt < MIN_COMPLETION_TIME_MS) {
      event.preventDefault();
      showMessage(messageElement, 'Please wait a moment, then try submitting the form again.');
      return;
    }

    const fingerprint = submissionFingerprint(form);
    if (wasRecentlySubmitted(fingerprint)) {
      event.preventDefault();
      showMessage(messageElement, 'This message was already sent. Please wait a few minutes before submitting it again.');
      return;
    }

    writeSessionValue(PENDING_STORAGE_KEY, fingerprint);
  });
}

document.querySelectorAll('[data-contact-honeypot]').forEach(protectContactForm);
